import axios from "@/api/axiosInstance";
import type {
  CreateTestCompanyRequest,
  CreateTestCompanyResponse,
} from "./types";

export const createTestCompany = async (
  payload: CreateTestCompanyRequest,
): Promise<CreateTestCompanyResponse> => {
  const response = await axios.post<CreateTestCompanyResponse>(
    "/api/private/admin/test-companies",
    payload,
  );
  return response.data;
};
